import {
  CustomerDTO,
  DistrictDTO,
  DistrictEmailNotificationDTO,
  DistrictSimpleDto,
} from 'src/app/common/dtos/district.dto';
import { SchoolDTO } from 'src/app/common/dtos/school.dto';
import { State } from 'src/app/common/utilities/enums/state.enum';
import {
  CustomerAPIResponse,
  DistrictAPIResponse,
  DistrictEmailNotificationsResponse,
  DistrictListAPIResponse,
  DistrictListSimpleAPIResponse,
  DistrictSimpleAPIResponse,
  SchoolAPIResponse,
} from '../../types/responses/district-list.responses';

export const schoolDTOFromAPIResponse = (
  item: SchoolAPIResponse
): SchoolDTO => ({
  address: item.address,
  address2: item.address2,
  counts: item.counts,
  district_id: item.district_id,
  id: item.id,
  title: item.title,
  isDeleted: item.is_deleted,
  city: item.city,
  state: <State>item.state,
  zip: item.zip,
  phone: item.phone,
  updated_at: item.updated_at,
});

const districtDTOFromAPIResponse = (
  item: DistrictAPIResponse
): DistrictDTO => ({
  domain: item.domain,
  logo: item.logo,
  timezone: item.timezone,
  counts: {
    users: item.counts ? item.counts.users : 0,
    schools: item.counts ? item.counts.schools : 0,
  },
  id: item.id,
  hubspotCompanyId: item.hubspot_company_id,
  districtCode: item.district_code,
  isB2b: item.is_b2b,
  isInternal: item.is_internal,
  tenantId: item.tenantId,
  parentDistrictId: item.parentDistrictId,
  title: item.title,
  isDeleted: item.is_deleted,
  address: item.address,
  address2: item.address2,
  city: item.city,
  state: <State>item.state,
  zip: item.zip,
  phone: item.phone,
  schools: item.schools.map((attendee) => schoolDTOFromAPIResponse(attendee)),
  reportingSchoolYear: item.reporting_school_year,
  createdAt: item.created_at,
  updatedAt: item.updated_at,
  defaultPrivateLogs: !!item.default_private_logs,
  users_can_login: item.users_can_login,
  nightlyDataExports: item.nightly_data_exports,
});

export const districtSimpleDTOFromAPIResponse = (
  item: DistrictSimpleAPIResponse
): DistrictSimpleDto => ({
  domain: item.domain,
  logo: item.logo,
  timezone: item.timezone,
  id: item.id,
  hubspotCompanyId: item.hubspot_company_id,
  districtCode: item.district_code,
  isB2b: item.is_b2b,
  isInternal: item.is_internal,
  title: item.title,
  isDeleted: item.is_deleted,
  address: item.address,
  address2: item.address2,
  city: item.city,
  state: <State>item.state,
  zip: item.zip,
  phone: item.phone,
  reportingSchoolYear: item.reporting_school_year,
  defaultPrivateLogs: !!item.default_private_logs,
  users_can_login: item.users_can_login,
  nightlyDataExports: item.nightly_data_exports,
});

export const districtListDTOFromAPIResponse = (
  response: DistrictListAPIResponse
): DistrictDTO[] =>
  response.items.map((item) => districtDTOFromAPIResponse(item));

export const districtListSimpleDTOFromAPIResponse = (
  response: DistrictListSimpleAPIResponse
): DistrictSimpleDto[] =>
  response.items.map((item) => districtSimpleDTOFromAPIResponse(item));

const customerDTOFromAPIResponse = (
  item: CustomerAPIResponse
): CustomerDTO => ({
  hubspotCompanyId: item.hubspot_company_id.toString(),
  name: item.name,
  address: item.address,
  city: item.city,
  state: <State>item.state,
  zip: item.zip,
  timezone: item.timezone,
  domain: item.domain,
  description: item.description,
  isArchived: item.is_archived,
  licenseCount: item.license_count,
});

export const customerListDTOFromAPIResponse = (response: {
  items: CustomerAPIResponse[];
}): CustomerDTO[] =>
  response.items.map((item) => customerDTOFromAPIResponse(item));

export const districtEmailNotificationDTOfromAPIResponse = (
  item: DistrictEmailNotificationsResponse
): DistrictEmailNotificationDTO => ({
  id: item.id,
  title: item.title,
  slug: item.slug,
  sortOrder: item.sort_order,
  isEnabled: item.districtEmailNotifications[0]
    ? item.districtEmailNotifications[0].is_enabled
    : 0,
});
